/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Share_Upload_StartedInputs */

const en_mobile_share_upload_started = /** @type {(inputs: Mobile_Share_Upload_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding to your library…`)
};

const es_mobile_share_upload_started = /** @type {(inputs: Mobile_Share_Upload_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadiendo a tu biblioteca…`)
};

/**
* | output |
* | --- |
* | "Adding to your library…" |
*
* @param {Mobile_Share_Upload_StartedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_share_upload_started = /** @type {((inputs?: Mobile_Share_Upload_StartedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Share_Upload_StartedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_share_upload_started(inputs)
	return en_mobile_share_upload_started(inputs)
});